<template>
  <footer class="footer-wrap">
    <div class="container">
      <div class="header">
        <div class="logo-wrap">
          <span class="logo" @click="$router.push({path:'/'})">fotty</span>
        </div>
        <div class="menu-wrap"></div>
          
        <div class="support-wrap">
          <a href="https://vk.com/im?sel=-187939287" target="_blank" class="button-group">
            <div>
              <span class="icon-wrap">
                <SvgIcon name="support_ico" width="21px" height="21"></SvgIcon>
              </span>
              <span class="title">Поддержка</span>
            </div>
          </a>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import SvgIcon from "@/components/basic/SvgIcon.vue";
import { mapGetters } from "vuex";

export default {
  name: "Footer",
  components: {
    SvgIcon
  },
  data() {
    return {
      currentRoute: this.$router.currentRoute.name
    };
  },
  watch: {
    $route(to) {
      this.currentRoute = to.name;
    }
  },
  computed: {
     ...mapGetters({
      'user':'user/get_user',
      'events': "events/get_events",
    })
  }
};
</script>

<style lang="scss" scoped>
.footer-wrap {
  width: 100%;
  height: 56px;
  background-color: $mainColor;
  color: #fff;
  .container {
    height: 100%;
  }
  .header {
    display: grid;
    grid-template-columns: 1fr 2fr 1fr;
    height: 100%;

    .logo-wrap {
      display: flex;
      align-items: center;
      .logo {
        cursor: pointer;
        font-weight: 900;
        font-size: 32px;
        line-height: 40px;
      }
    }
    .menu-wrap,
    .support-wrap {
      display: flex;
      align-items: center;
    }
    .support-wrap {
      justify-content: flex-end;
    }
    .button-group {
      @extend %bRadius;
      padding: 6px 12px;
      //   color: #fff;
      //   a{
      //       color: #fff;
      //   }
      &:not(:last-child) {
        margin-right: 16px;
      }
      .icon-wrap {
        padding: 3.5px;
        margin-right: 8px;
      }
      &.active,&.router-link-active {
        background: rgba(255, 255, 255, 0.1);
        border: 1px solid rgba(255, 255, 255, 0.2);
      }
    }
  }
}
</style>